import API from './api';

export default {
    createGroupInviteLink: (data) => API({
        url: 'group-invite-links',
        method: 'POST',
        json: data,
    }),

    getGroupInviteLinks: (groupId) => API({
        url: `group-invite-links/groups/${groupId}`,
        method: 'GET',
    }),

    updateGroupInviteLink: (inviteCode, data) => API({
        url: `group-invite-links/${inviteCode}`,
        method: 'PATCH',
        json: data,
    }),

    deactivateGroupInviteLink: (inviteCode) => API({
        url: `group-invite-links/${inviteCode}`,
        method: 'PATCH',
        json: { is_active: false },
    }),
};
